export const EXPAND_CHILDREN_THRESHOLD_MS = 1000
export const NESTING_RAISING_THRESHOLD_PRECENT = 30
export const DND_ACTIVATION_THRESHOLD_MS = 400
